import { Container } from '@almbrand/container';
import { Grid } from '@almbrand/grid';
import classNames from 'classnames';
import styles from './OverlayModel.module.scss';

export interface OverlayModelProps {
	children: React.ReactNode;
	hasNoBackground?: boolean;
}

export const OverlayModel: React.FC<OverlayModelProps> = ({ children, hasNoBackground = false }) => {
	return (
		<Container
			className={styles.OverlayModel__container__outer}
			desktopWidth='1600'
			tabletWidth='fullWidth'
			mobileWidth='fullWidth'
		>
			<Container
				className={styles.OverlayModel__container__inner}
				desktopWidth='2500'
				tabletWidth='1600'
				mobileWidth='fullWidth'
			>
				<Grid
					className={classNames(
						styles.OverlayModel__model,
						hasNoBackground && styles.OverlayModel__model__IsTransparent
					)}
					container
					nogutter
				>
					{children}
				</Grid>
			</Container>
		</Container>
	);
};
